import { ActionFunctionArgs, redirect } from "react-router-dom";
import { ManageCourseCreateSectionDTO } from "../types/manageCourseActionTypes";
import { apiEndpoints } from "@/services/api/api";

export async function AdminManageCourseCreateSectionAction({
  request,
  params,
}: ActionFunctionArgs) {
  const formData = await request.formData();
  const courseId = params.courseId;

  if (!courseId || !params.courseId) {
    throw new Error("Course ID is required");
  }
  const dataObject = Object.fromEntries(formData.entries()) as Omit<
    ManageCourseCreateSectionDTO,
    "courseId"
  >;

  const enhancedData: ManageCourseCreateSectionDTO = {
    ...dataObject,
    courseId: courseId,
  };
  try {
    const result = await apiEndpoints.lecturerCreateSection(enhancedData);
    if (!result.success) {
      throw new Error(result.message || "Failed to create section");
    }
    return redirect(`/admin-panel/manage-courses-in-detail/${params.courseId}/content`);
  } catch (error) {
    console.error("Error creating section:", error);
    throw new Error("Failed to create section");
  }
}
